// getPrivateShowProductId.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getGoalData from '../selector/getGoalData.js';

/**
 * Select private show product id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - stream id.
 * @param {string} fundingId - funding goal id.
 * @param {string} performingId - performing goal id.
 * @return {string|undefined} Return product id.
 */
const getPrivateShowProductId = createCachedSelector(
  (state, streamId, fundingId) =>
    getGoalData(state, [fundingId, 'context'], 'ticket_product_id'),
  (state, streamId, fundingId, performingId) =>
    getGoalData(state, [performingId, 'context'], 'ticket_product_id'),
  (fundingProductId, showProductId) => {
    return showProductId || fundingProductId;
  }
)(
  (state, streamId, fundingId, performingId) =>
    `${streamId}:${fundingId}:${performingId}`
);

export default getPrivateShowProductId;
